<script setup>
import {ref} from 'vue'
import CustomMask from "@/components/NewPC/CustomMask.vue";

const MaskRef = ref(null);

const open = () => {
  MaskRef.value?.open()
}

defineExpose({open})
</script>

<template>
<custom-mask ref="MaskRef">
  <div class="content">
    <img src="@/assets/newPc/close_icon.png" alt="" class="close_icon" @click="open" />
    <div class="title">适龄提示：</div>
    <div class="text_block">
      <div>（1) 本游戏是一款体育竞技类游戏，适用于年满12周岁及以上的用户，建议未成年人在家长监管下使用游戏产品。</div>
      <div>（2） 本游戏基于架空的故事背景以打篮球为核心游戏玩法。本游戏玩法基于一定难度的肢体操作，鼓励玩家通过思考、练习和与队友配合达成赢得比赛的游戏目标，游戏中有基于文字和语音的陌生人社交系统。</div>
      <div>（3） 本游戏有用户实名认证系统，认证为未成年人的用户将接受以下管理：游戏中部分玩法和道具需要付费。8周岁以下（不含）无法进行充值。8周岁至16周岁（含8周岁，不含16周岁） 充值单次不超过50元，每月累计不超过200元。16周岁至18周岁（含16周岁，不含18周岁）充值单次不超过100元，每月累计不超过400元。未成年玩家仅可在周五、周六、周日及法定节假日，每日20时至21时期间登录游戏，到达规定时间后将被强制下线，当日不能再登录游戏。其他时间无法登录游戏。</div>
      <div>（4）本游戏以篮球运动为主题，鼓励玩家提高球技、结识朋友。本游戏传达了追求卓越、永远向上的体育精神和价值观，力图带给玩家美好的游戏体验。</div>
    </div>
  </div>
</custom-mask>
</template>

<style scoped lang="scss">
.content {
  width: 43.203125vw;
  height: 22.8515625vw;
  background: transparent url("@/assets/newPc/tips_12_bg.png") no-repeat center center;
  background-size: cover;
  position: relative;
  padding: 1.953125vw 0.5vw 3.3984375vw 2.4609375vw;
  font-family: 'SourceHanSansCN-Medium';
  color: #A9AED0;
  box-sizing: border-box;

  .title {
    font-size: 1.015625vw;
    margin-bottom: 1.5625vw;
  }

  .text_block {
    width: 37.9296875vw;
    height: 14.8828125vw;
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 0.859375vw;
    padding-right: 1.9609375vw;
  }

  .close_icon {
    width: 1.6015625vw;
    height: 1.6015625vw;
    position: absolute;
    right: 0.703125vw;
    top: 0.703125vw;
    cursor: pointer;
  }
}
</style>